import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DirectionsBusFilledIcon from '@mui/icons-material/DirectionsBusFilled';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PlaceIcon from '@mui/icons-material/Place';
import StopCircleIcon from '@mui/icons-material/StopCircle';

import BusTourPage from './BusTourPage';

const exports = {
    Page: BusTourPage,
    Icon: DirectionsBusIcon,
    LineSetsIcon: FormatListBulletedIcon,
    BusesIcon: DirectionsBusFilledIcon,
    AttractionsIcon: PlaceIcon,
    BusStopsIcon: StopCircleIcon,
};
export default exports;
